import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { PackageModel } from '../business-entities/package-model';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import {PackageListRequestModel} from '../business-entities/package-list-request-model';

@Injectable({
    providedIn: 'root'
})

export class PackageDataService
{
    constructor(private dataProvider: DataService) {
    }

    async getPackage(id:string,code:any): Promise<GenericResponse<Array<PackageModel>>> {
        return this.dataProvider.Get<GenericResponse<Array<PackageModel>>>(Urls.GetPackage,id,code).toPromise();
    }

    AddPackage(model: any): Promise<any> {
        return this.dataProvider.Post<any>(Urls.AddPackage, model).toPromise();
    }
    EditPackage(model: any): Promise<any> {
        return this.dataProvider.Put<any>(Urls.EditPackage, model).toPromise();
    }
    
    deletePackage(Id: string):Promise<GenericResponse<boolean>> {
        return this.dataProvider.Delete<GenericResponse<boolean>>(Urls.DeletePackage, Id).toPromise();
    }
    getPackageById(packageNumber:string):Promise<any>{
        return this.dataProvider.Get<GenericResponse<Array<PackageModel>>>(Urls.GetPackageById,packageNumber).toPromise();
    }

    getPackageList(packageListRequestModel:PackageListRequestModel):Promise<any>
    {
        return this.dataProvider.Post<any>(Urls.GetPackageList,packageListRequestModel).toPromise();
    }

    GetPackageVersionByPackageNo(packageId:number,langCode:string):Promise<any>
    {
        return this.dataProvider.Get<any>(Urls.GetPackageVersionByPackageNo,packageId,langCode).toPromise();
    }

    GetPackageBOMByPackageNo(packageId:number,packageVersionId:number,dealerId:string,allowDealerBrandLaborRate:boolean):Promise<any>
    {
        return this.dataProvider.Get<any>(Urls.GetPackageBOMByPackageNo,packageId,packageVersionId,dealerId,allowDealerBrandLaborRate).toPromise();
    }

    GetBillOfMaterialType():Promise<any>
    {
        return this.dataProvider.Get<any>(Urls.GetBillOfMaterialType).toPromise();
    }

    async GetPackageDetails(packageId:number):Promise<any>
    {
        return this.dataProvider.Get<any>(Urls.GetPackageDetail,packageId).toPromise();
    }

    AddUpdatePackage(packageRequestModel: any): Promise<any> {
        return this.dataProvider.Post<any>(Urls.AddUpdatePackage, packageRequestModel).toPromise();
    }
    async getSearchPackage(model: any): Promise<any> {
        return this.dataProvider.Post<any>(Urls.SearchPackageDetail, model).toPromise();
    }
    DeletePackageVersion(packageId: number,packageVersionId:number):Promise<any> {
        return this.dataProvider.Get<any>(Urls.DeletePackageVersion, packageId,packageVersionId).toPromise();
    }

    DeletePackageByNumber(packageId: number):Promise<any> {
        return this.dataProvider.Get<any>(Urls.DeletePackageByNumber, packageId).toPromise();
    }

    async ResyncPackage(packageId: number): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.ResyncPackage, packageId).toPromise();
    }

    async getAfxPackageDropdown(model: any): Promise<any> {
        return  this.dataProvider.Post<any>(Urls.GetAfxPackageDropdown, model).toPromise();
    }

    async GetPackageBOMByDealerServiceId(dealerServiceId: number):Promise<any>{
        return this.dataProvider.Get<any>(Urls.GetPackageBOMByDealerServiceId,dealerServiceId).toPromise();
    }
    
    async DuplicatePackage(packageRequestModel: any): Promise<any> {
        return this.dataProvider.Post<any>(Urls.DuplicatePackage, packageRequestModel).toPromise();
    }
}